import React from 'react';
import { JournalBrandNewsLayout } from '@/features/journal/brand-news';
import { brandNews } from '@/features/journal/news-groups';
import { JournalPressLayout } from '@/features/journal/press';
import { GetServerSidePropsContext } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { PageLayout } from '@/layouts/shared';
import withAuthServerSideProps from '@/libs/auth';
import { JournalTopicLayout, JournalTopicProps, TOPIC_BY_SLUG } from '@/features/journal';
import { JournalPromoLayout } from '@/features/journal/promo-layout';
import { byTopic, loadJournal, loadPromos } from '@/features/journal/data';
import { Promo, PromoImages } from '@/features/journal/promo';
import { JournalArticle } from '@/features/journal/const';
import { loadNewsCategory } from '@/features/journal/category-data';

type PageProps =
  | { brandArticles: JournalArticle[] }
  | { pressArticles: JournalArticle[]; pressUnavailable: boolean }
  | JournalTopicProps
  | { promoImages: PromoImages; promos: Promo[]; news: JournalArticle[] };

const JournalTopicPage = (props: PageProps) =>
  'brandArticles' in props ? <JournalBrandNewsLayout articles={props.brandArticles} /> :
  'pressArticles' in props ? <JournalPressLayout articles={props.pressArticles} unavailable={props.pressUnavailable} /> :
  'promoImages' in props ? <JournalPromoLayout images={props.promoImages} promos={props.promos} news={props.news} /> :
  <JournalTopicLayout {...props} />;

export const getServerSideProps = withAuthServerSideProps(
  async ({ locale, query }: GetServerSidePropsContext) => {
    const requested = String(query.topic || '');
    if (requested === 'kim-cuong' || requested === 'trang-suc') {
      return { redirect: { permanent: true, destination: `/tin-tuc/kien-thuc-${requested}/` } };
    }
    const slug = requested === 'kien-thuc-kim-cuong' ? 'kim-cuong' : requested === 'kien-thuc-trang-suc' ? 'trang-suc' : requested;
    if (slug === 'tin-an-thu') {
      const [journal, promoData] = await Promise.all([loadJournal(), loadPromos()]);
      return {
        props: {
          brandArticles: brandNews(journal.articles, promoData.promos.map((promo) => promo.article)),
          layout: PageLayout.Journal,
          ...(await serverSideTranslations(locale as string, ['layout', 'consult', 'order'])),
        },
      };
    }
    if (slug === 'bao-chi') {
      const { articles, unavailable } = await loadNewsCategory('bao-chi');
      return {
        props: {
          pressArticles: articles,
          pressUnavailable: unavailable,
          layout: PageLayout.Journal,
          ...(await serverSideTranslations(locale as string, ['layout', 'consult', 'order'])),
        },
      };
    }
    // /tin-tuc/khuyen-mai/: trang Khuyến mãi
    if (slug === 'khuyen-mai') {
      const [promoData, journal] = await Promise.all([loadPromos(), loadJournal()]);
      return {
        props: {
          promoImages: promoData.images,
          promos: promoData.promos,
          // Chỉ bài thuộc category Khuyến mãi; tin nội bộ hiển thị ở Tin Tức An Thư.
          news: journal.articles.filter((article) => article.promotion).slice(0, 12),
          layout: PageLayout.Journal,
          ...(await serverSideTranslations(locale as string, ['layout', 'consult', 'order'])),
        },
      };
    }
    const topic = TOPIC_BY_SLUG[slug];
    // /tin-tuc/bang-gia/ → trang Bảng giá chính thức
    if (topic?.slug === 'bang-gia') return { redirect: { permanent: true, destination: '/bang-gia/' } };
    if (!topic) return { notFound: true };
    const { articles } = await loadJournal();
    return {
      props: {
        slug: topic.slug,
        articles: byTopic(articles, topic.slug),
        layout: PageLayout.Journal,
        ...(await serverSideTranslations(locale as string, ['layout', 'consult', 'order'])),
      },
    };
  },
  { isAntiAuth: false, isPublic: true }
);
export default JournalTopicPage;
